module.exports = __webpack_public_path__ + "static/img/kj1-11.fca0dc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/kj1-11.png
// module id = 934
// module chunks = 0